import { SORT_LIST, TOGGLE_LIST_SHARE } from '../actions';

type State =
  | {
      key: number;
      sort: string | null;
      direction: string | null;
      openShareId: string | null;
    }
  | undefined;

type Action =
  | {
      type: 'SORT_LIST';
      sort: {
        value: string;
      };
    }
  | {
      type: 'TOGGLE_LIST_SHARE';
      uid: string;
    };

export default function publicListReducer(state: State, action: Action) {
  if (!state) {
    return {
      key: 0,
      sort: null,
      direction: null,
      openShareId: null,
    };
  }

  switch (action.type) {
    case SORT_LIST: {
      const [sort, direction] = action.sort.value.split(':');

      return {
        ...state,
        key: state.key + 1,
        sort,
        direction,
      };
    }

    case TOGGLE_LIST_SHARE: {
      return {
        ...state,
        openShareId: !state.openShareId ? action.uid : null,
      };
    }

    default:
      return state;
  }
}
